import './index.css';
import { useEffect } from 'react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { SpeedInsights } from '@vercel/speed-insights/react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  RouterProvider,
  useLocation,
  useNavigationType
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { getStatsigProvider } from './providers/statsig-provider';
import { routes } from './routes';
import { VercelToolbar } from './components/VercelToolbar';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://5f961698504d1baf5507b50c6412e1e2@o4507902530224128.ingest.us.sentry.io/4508091865366528',
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false
      }),
      Sentry.captureConsoleIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: window.location.hostname === 'app.getcontextual.io'
  });
}

// We are on react router v6

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
const router = sentryCreateBrowserRouter(routes);

const renderApp = () => {
  const StatsigProvider = getStatsigProvider();
  // Render the app
  const rootElement = document.getElementById('root')!;
  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <StrictMode>
        <StatsigProvider>
          <SpeedInsights />
          <RouterProvider router={router} />
          <VercelToolbar />
        </StatsigProvider>
      </StrictMode>
    );
  }
};

renderApp();
